import React from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin, Clock } from 'lucide-react';
import { motion } from 'framer-motion';

export default function ExperienceCard({ experience, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Link
        to={`/upplevelse/${experience.id}`}
        className="experience-card block group"
        data-testid={`experience-card-${experience.id}`}
      >
        <div className="relative overflow-hidden">
          <img
            src={experience.image_url}
            alt={experience.name}
            className="w-full aspect-[4/3] object-cover"
            loading="lazy"
          />
          <div className="absolute top-4 right-4">
            <span className="price-tag text-sm">
              {experience.price.toLocaleString('sv-SE')} kr
            </span>
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-1 text-[#C4A77D] mb-2">
            <Star className="w-4 h-4 fill-current" />
            <span className="text-sm font-medium">{experience.rating}</span>
            <span className="text-[#8C8C8C] text-sm">({experience.reviews_count})</span>
          </div>
          <h3 className="font-['Avenir_Next'] text-xl text-[#1A1A1A] group-hover:text-[#C4A77D] transition-colors">
            {experience.name}
          </h3>
          <p className="text-[#595959] text-sm mt-2 line-clamp-2">
            {experience.description}
          </p>
          <div className="flex items-center gap-4 mt-4 text-[#8C8C8C] text-sm">
            <span className="flex items-center gap-1">
              <MapPin className="w-4 h-4" />
              {experience.location}
            </span>
            <span className="flex items-center gap-1">
              <Clock className="w-4 h-4" />
              {experience.duration}
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
